<template>
	<div class="container">
		<div class="section-wrapper top-wrapper">
			<div>
				<mt-field
						class="input-wrapper"
						v-model="username"
						placeholder="Username"
						maxlength="25"
				/>
			</div>
		</div>
		<label class="tips">User name is 3-25 digits, can include English and numbers</label>
		<div class="section-wrapper bottom-wrapper">
			<div>
				<mt-field
						type="password"
						class="input-wrapper"
						v-model="password"
						placeholder="Set password"
						maxlength="20"
				/>
			</div>
			<div>
				<mt-field
						type="password"
						class="input-wrapper"
						v-model="confirmPassword"
						placeholder="Confirm password"
						maxlength="20"
				/>
			</div>
		</div>
		<label class="tips">6-20 digits/letters/symbols</label>
		<mt-button class="ds-button-large mt-10 mb-10" type="primary" v-on:click="onSubmit">Bind</mt-button>
		<div class="link-wrapper">
			<span class="left-text">Click to bind to agree</span>
			<span class="right-text" @click="onAgreement">"User Agreement"</span>
		</div>
	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { bind, getThirdLogin } from '../../../api/memberLogin'
export default {
  name: 'BindNew',
  data () {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      aggrementUrl: '',
      wxinfo: false
    }
  },
  created: function () {
	  getThirdLogin().then(res => {
		  let wxinfo = res.result.wxinfo
		  if (!wxinfo) {
			  Toast('Binding information does not exist')
			  this.$router.push({ name: 'HomeMemberLogin' })
		  } else {
			  this.wxinfo = wxinfo
		  }
	  })
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    })
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    goBack () {
      this.$router.go(-1)
    },
    goProfile () {
      this.$router.go(-2)
    },
    goProfileAdd () {
      this.$router.push({ name: 'profileAdd' })
    },
    check () {
      let username = this.username
      let password = this.password
      let confirmPassword = this.confirmPassword
      if (username.length === 0) {
        Toast('Please enter a username of 3-25 characters')
        return false
      }
      if (username.length < 3 || username.length > 25) {
        Toast('Please enter a username of 3-25 characters')
        return false
      }
      if (password.length === 0) {
        Toast('Please enter the password')
        return false
      }
      if (password.length < 6 || password.length > 20) {
        Toast('Please enter a password of 6-20 characters')
        return false
      }
      if (confirmPassword.length === 0) {
        Toast('Please enter confirm password')
        return false
      }
      if (password.length !== confirmPassword.length) {
        Toast('Confirm password is inconsistent with input password')
        return false
      }
      if (password !== confirmPassword) {
        Toast('Confirm password is inconsistent with input password')
        return false
      }
      return true
    },
    signup () {
      if (!this.check()) {
        return
      }
      Indicator.open()
      bind(1, this.wxinfo.from, this.wxinfo.openid, this.wxinfo.unionid, this.wxinfo.nickname, this.wxinfo.headimgurl, this.username, this.password, this.confirmPassword, this.inviter_id).then(
        response => {
          Indicator.close()
          if(response.code == '10001'){
            Toast(response.message)
          }else{
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            this.$router.push({ name: 'MemberIndex' })
          }
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit () {
      this.signup()
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		//background-color: #e93b3d;
		.section-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: stretch;
			background-color: #ffffff;
			border-top: 1px solid #e8eaed;
			border-bottom: 1px solid #e8eaed;
			.input-wrapper {
				font-size: .7rem;
				display: flex;
				flex-direction: row;
				align-content: flex-start;
				align-items: center;
				background-color: #fff;
				height:2.2rem;
				padding-left:0.5rem;
				input {
					flex: 1;
				}
				.bottom-input {
					border-bottom-width: 0;
				}
			}
		}
		.link-wrapper {
			height:2.2rem;
			margin-top:0.5rem;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: stretch;
			span {
				font-size:0.7rem;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
			}
			.left-text {
				color: #c3c3c3;
			}
			.right-text {
				color: $primaryColor;
			}
		}
	}
	.top-wrapper {
		margin-top:0.5rem;
	}
	.bottom-wrapper {
		margin-top:0.5rem;
	}
	.tips {
		color: #c3c3c3;
		font-size:0.6rem;
		margin-left: 0.9rem;
		margin-top:0.5rem;
		text-align: left;
	}
</style>
